// extracted by mini-css-extract-plugin
module.exports = {"Tagline":"Contact_Tagline__3NnaT","Link":"Contact_Link__3xg67"};